import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLBackLink } from '../components/SMLBackLink/SMLBackLink';
import { chartsTabLabels, ChartsTabScreen } from './chartsTabs';
import styles from './ChartsBackLink.module.scss';

interface ChartsBackLinkProps {
  /** The Charts tab the page belongs to: Artists for an artist. */
  tab: ChartsTabScreen;
}

/**
 * The back link of an artist, a track or a playlist (design navigation-v2 e 5c). It goes back to
 * where the reader came from (a chart, the Watchlist, a search). On the first page of the session
 * (a link from an email or a new tab) it opens the matching Charts tab.
 */
const ChartsBackLinkComponent: React.FC<ChartsBackLinkProps> = ({ tab }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const { canGoBack, goBack } = router;
  const back = useCallback(() => goBack(SMLRoutes[tab]), [goBack, tab]);

  return (
    <div className={clsx('mb-2', styles.back)}>
      <SMLBackLink
        to={SMLRoutes[tab]}
        destination={intl.formatMessage(chartsTabLabels[tab])}
        onClick={canGoBack ? back : undefined}
      />
    </div>
  );
};

export const ChartsBackLink = TypedMemo(ChartsBackLinkComponent);
